import type { FC } from 'react';
import React, { useMemo } from 'react';
import { useFormState } from 'react-final-form';
import md5 from 'md5';

import { HiddenInput } from '../hidden-input';

import type { IProps } from './models';

/**
 * Записывает в скрытый инпут md5-хеш значения поля формы
 */
export const HashField: FC<IProps> = ({
    dataTestId = 'hashField',
    hashedField,
    name,
    valueFilter,
}) => {
    const { values } = useFormState({ subscription: { values: true } });

    const value = values[hashedField];

    const hashedValue = useMemo(() => {
        let result: string | undefined;

        if (['string', 'number'].includes(typeof value)) {
            const preparedValue = valueFilter
                ? value.toString().replace(RegExp(valueFilter, 'g'), '')
                : value;

            result = md5(preparedValue);
        }

        return result;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    return <HiddenInput dataTestId={dataTestId} name={name} value={hashedValue} />;
};
